"use strict";

module.exports = {
  'space-1': {
    value: '.4rem'
  },
  'space-2': {
    value: '.8rem'
  },
  'space-3': {
    value: '1.6rem'
  },
  'space-4': {
    value: '2.4rem'
  },
  'space-5': {
    value: '3.2rem'
  },
  'space-6': {
    value: '4rem'
  },
  'space-7': {
    value: '4.8rem'
  },
  'space-8': {
    value: '5.6rem'
  },
  'space-9': {
    value: '6.4rem'
  },
  frapPadding: {
    value: '9rem'
  },
  frapPaddingDouble: {
    value: '14.6rem'
  },
  // logoOffsets are size of logo in the global nav plus left & right margin around the logo
  logoOffsetMd: {
    value: '99px'
  },
  logoOffsetLg: {
    value: '131px'
  },
  outerGutter: {
    value: '1.6rem'
  },
  outerGutterMedium: {
    value: '2.4rem'
  },
  outerGutterLarge: {
    value: '4.0rem'
  },
  headerCrateOuterGutterLarge: {
    value: '4.0rem'
  }
};